import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import Button from '@material-ui/core/Button';
import { handleChangeEvent, handleDateChangeEvent, handlePatch } from '../../../../../utils/AxiosUtil';
import * as enums from '../../../../../utils/EnumMapping';
import * as util from '../../../../../utils/Util';
import ErrorAwareAmountField from '../../../../common/inputfields/ErrorAwareAmountField';
import ErrorAwareDatePicker from '../../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTextField from '../../../../common/inputfields/ErrorAwareTextField';
import PaymentMethodFormControl from '../../../../common/inputfields/PaymentMethodFormControl';

class ModifyDividend extends Component {
    state = {
        selectedPaymentMethod: enums.outPaymentMethods.find(p => p.value === this.props.row.paymentMethod),
        grossAmount: this.props.row.grossAmount,
        netAmount: this.props.row.netAmount,
        comment: this.props.row.comment,
        date: new Date(this.props.row.date),
        errors: new Map(),
    }

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();

        const path = '/api/dividend';
        const requestObject = {
            "privateId": this.props.row.privateId,
            "employeeId": this.props.row.employeeId,
            "paymentMethod": this.state.selectedPaymentMethod.value,
            "grossAmount": util.toNumber(this.state.grossAmount),
            "netAmount": util.toNumber(this.state.netAmount),
            "date": this.state.date,
            "comment": this.state.comment,
        };

        handlePatch(path, requestObject, this);
    };

    render() {
        return (
            <form onSubmit={this.handleSubmit}>
                <div className='flex-form'>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            disabled
                            name="employee"
                            label="Munkavállaló"
                            errors={this.state.errors}
                            value={this.props.row.employeeName} />
                    </div>
                    <div className='input-group'>
                        <PaymentMethodFormControl
                            options={enums.outPaymentMethods}
                            value={this.state.selectedPaymentMethod}
                            prevValue={enums.getObjectByValue(enums.outPaymentMethods, this.props.row.paymentMethod)}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="netAmount"
                            label="Nettó összeg"
                            value={this.state.netAmount}
                            errors={this.state.errors}
                            prevValue={this.props.row.netAmount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareAmountField
                            required
                            name="grossAmount"
                            label="Bruttó összeg"
                            value={this.state.grossAmount}
                            errors={this.state.errors}
                            prevValue={this.props.row.grossAmount}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareDatePicker
                            required
                            name="date"
                            label="Dátum"
                            errors={this.state.errors}
                            value={this.state.date}
                            prevValue={this.props.row.date}
                            onChange={e => handleDateChangeEvent(e, "date", this)} />
                    </div>
                    <div className='input-group'>
                        <ErrorAwareTextField
                            name="comment"
                            label="Megjegyzés"
                            errors={this.state.errors}
                            value={this.state.comment}
                            prevValue={this.props.row.comment}
                            onChange={e => handleChangeEvent(e, this)} />
                    </div>
                </div>
                <div className="form-actions">
                    <Button className="btn-submit" variant="contained" color="primary" type="submit">
                        Módosítás
                    </Button>
                </div>
            </form>
        )
    }
}

export default withSnackbar(ModifyDividend);
